import React from "react";
import styled from "styled-components";
import ErrorImage from "./ErrorImage";
const ErrorPage = () => {
  return (
    <MainErrorPage>
      <ErrorImage />
      <ErrorTitle>
        Woops! <br /> Something went wrong :(
      </ErrorTitle>
      <ErrorSubTitle>Have you tried reloading the page?</ErrorSubTitle>
    </MainErrorPage>
  );
};

export default ErrorPage;

export const MainErrorPage = styled.div`
  margin: 40px auto;
  width: 80vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  border-radius: 12px;
`;
export const ErrorTitle = styled.h1`
  max-width: 529px;
  font-family: Roboto;
  font-size: 38px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4b4b62;
  margin-bottom: 16px;
`;

export const ErrorSubTitle = styled.h2`
  max-width: 568px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #4b4b62;
  margin-bottom: 24px;
`;
